import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Header = ({ page }) => {

  const [headerText, setHeaderText] = useState('');

  useEffect(() => {
    if (page?.[0]?.content?.[0]?.text) {
      setHeaderText(page[0].content[0].text);
    } else {
      setHeaderText('Ayudo a negocios a tener presencia online y automatizar el seguimiento de clientes con páginas web modernas y sistemas de recordatorios.');
    }
  }, [page]);

  const divRefOne = useRef(null);
  const divRefTwo = useRef(null);

  const [refOne, inViewOne] = useInView({ threshold: 0.5, triggerOnce: true });
  const [refTwo, inViewTwo] = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <>
      <header className="masthead header-home" id="page-top">
        <div className="container px-4 px-lg-5 h-100">
          <div className="row gx-4 gx-lg-5 h-100 align-items-center justify-content-center text-center" id="headerhome">
            <motion.div
              ref={divRefOne}
              className={`animate ${inViewOne ? 'show' : ''} col-lg-8 align-self-end `}
              initial={{ opacity: 0, y: -100 }}
              animate={inViewOne ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1 }}
            >
              <div className="" ref={refOne}>
                <h1 className="font-weight-bold ">{headerText}</h1>
                <hr className="divider" />
              </div>
            </motion.div>

            <motion.div
              ref={divRefTwo}
              className={`animate ${inViewTwo ? 'show' : ''} col-lg-8 align-self-baseline `}
              initial={{ opacity: 0, x: -100 }}
              animate={inViewTwo ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 1 }}
            >
              <div className="" ref={refTwo}>
                <p className="text-75 mb-5">
                  Con más de 4 años de preparación y experiencia en desarrollo de páginas y aplicaciones web.
                </p>
                <a className="btn btn-primary btn-general" href="#about">Sobre mí</a>
              </div>
            </motion.div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
